export default __webpack_public_path__ + "images/Y8.f9268ac.png";